module.exports = __webpack_public_path__ + "img/process_table.2e1875dd.png";